import PropTypes from 'prop-types';
import styles from './FJButtonInCreditIcon.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import cionNew from '../../../assets/base64/cion-new.js';
import FJUtil from '../../../util/FJUtil.js';
import useDefaultFreeLimit from '../../../hooks/useDefaultFreeLimit.jsx';
import FJConfig from '../../../config/FJConfig.js';

const FJButtonInCreditIcon = props => {
    const { isFree, freeNumCreation, useCredit, isSmall = false, defaultFreeNumCreation } = props;

    const isLogin = FJUtil.isLogin();

    if (isSmall) {
        return (
            <>
                {!isLogin && defaultFreeNumCreation > 0 && (
                    <div className={styles.small_free_tries}>{FJLocalStore._('free-try')}</div>
                )}
                {isFree && isLogin && (
                    <div className={styles.small_free_tries}>
                        {freeNumCreation === 1
                            ? FJLocalStore._('free-trie-left')
                            : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                    </div>
                )}
                {!isFree && isLogin && (
                    <div className={styles.small_use_credit}>
                        {FJLocalStore._('use-credit').replace('xxx', useCredit)}
                    </div>
                )}
            </>
        );
    }

    return (
        <>
            {!isLogin && defaultFreeNumCreation > 0 && (
                <div className={styles.free_tries}>{FJLocalStore._('free-try')}</div>
            )}
            {isFree && isLogin && (
                <div className={styles.free_tries}>
                    {freeNumCreation === 1
                        ? FJLocalStore._('free-trie-left')
                        : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                </div>
            )}
            {!isFree && isLogin && (
                <div className={styles.use_credit}>
                    <img src={cionNew} alt='credit' className={styles.credit_icon} />
                    {FJLocalStore._('xxx/image').replace('xxx', useCredit)}
                </div>
            )}
        </>
    );
};

FJButtonInCreditIcon.propTypes = {
    isFree: PropTypes.bool,
    freeNumCreation: PropTypes.number,
    useCredit: PropTypes.number,
    isSmall: PropTypes.bool,
};

export default FJButtonInCreditIcon;
